import { AKUA_ENABLED } from "../config";
import analiticas from "./analiticas";
import clientes from "./clientes";
import contracargos from "./contracargos";
import customization from "./customization";
import dashboard from "./dashboard";
import descuentos from "./descuentos";
import facturacion from "./facturacion";
import liquidaciones from "./liquidaciones";
import pagos from "./pagos";
import pedidos from "./pedidos";
import products from "./products";
import reconciliacion from "./reconciliacion";
import terminales from "./terminales";

// ==============================|| MENU ITEMS ||============================== //

const baseMenuItems = [dashboard, pedidos, products, clientes, analiticas, descuentos, customization];

// Agregar items de Akua al final cuando esté habilitado (pagos, terminales, facturación, reconciliación, liquidaciones, contracargos)
const menuItems = AKUA_ENABLED ? [...baseMenuItems, pagos, terminales, facturacion, reconciliacion, liquidaciones, contracargos] : baseMenuItems;

const menuItemsAdmin = {
  items: menuItems,
};

const menuItemsExport = menuItemsAdmin;

export default menuItemsExport;
